import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Box, Button, Tabs, Tab } from '@material-ui/core';
import { useStyles } from '../styles';
import ReviewScreen from './ReviewScreen';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Store } from '../Store';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';


const Cart = () => {
  const { state } = useContext(Store);
  const { orderItems, itemsCount, totalPrice, taxPrice } = state.order;
  const styles = useStyles();
  const history = useHistory();
  const [tabSel, setTabSel] = React.useState(1);

  let { setting } = state.userSetting;
  if(!setting){
    setting = JSON.parse(localStorage.getItem("userInfo"));
  }

  const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }

  const goto = (subpath) => {
    history.push('/'+subpath+'?' + window.location.href.split('?')[1]);
  }

  const previewOrderHandler = () => {
    history.push(`/select-payment?` + window.location.href.split("?")[1]);
  };

  return (
    <Box
      className={styles.root}
      style={{ padding: "0px!important", backgroundColor: setting.themeColor, overflow:"hidden!important" }}
    >
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 2, pb: 1 }}>
        <ArrowBackIosNewIcon 
          style={{color: setting.themeTxtColor}} 
          onClick={() => history.goBack()}
        />
        <Typography variant="h4" style={{ color:'#fff', fontFamily: setting.themePrimaryFontFam }}>
          Your Cart
        </Typography>
        <Box style={{width: "24px"}} /> {/* Spacer for alignment */}
      </Box>

      <Box style={{height: "calc(100vh - 130px)", overflow:"hidden", overflowY:"auto" }}>
        <Typography 
          variant="h5" 
          style={{ 
            color: setting.themeTxtColor,
            textAlign: 'left',
            marginBottom: '10px',
            paddingLeft: '16px',
            fontWeight: 'bold',
             fontFamily: setting.themeSecondaryFontFam
          }}
        >
          Cart Order
        </Typography>
        <Typography 
          variant="body1" 
          style={{ 
            color: setting.themeTxtColor,
            textAlign: 'left',
            marginBottom: '20px',
            paddingLeft: '16px',
             fontFamily: setting.themeSecondaryFontFam
          }}
        >
          You have {itemsCount} {itemsCount === 1 ? 'item' : 'items'} in your cart
        </Typography>
        <ReviewScreen />
      </Box>

       <Tabs 
        style={{
          backgroundColor: setting.themeTxtColor,
          borderTop: "2px solid " + setting.themeColor,
          padding:"10px"
        }} 
        className="footer-tab" 
        value={tabSel} 
        onChange={handleTabChange} 
        aria-label="tabs footer"
      >
        <Tab 
          style={{
            background: tabSel==0 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==0 ? '#fff' : ""
          }} 
          onClick={() => goto('order')} 
          icon={<HomeIcon />}  
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==1 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==1 ? '#fff' : "",
            position: 'relative',
          }} 
          onClick={() => goto('cart')} 
          icon={
            <Box sx={{ position: 'relative', padding: '4px' }}>
              <ShoppingCartIcon />
             
               {state.order.itemsCount > 0 && (
                          <span className={"badge"} style={{background:'red',color:'#fff'}}>
                            {state.order.itemsCount}
                          </span>
                        )}
             
            </Box>
          }
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==2 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==2 ? '#fff' : ""
          }} 
          onClick={() => {
            setTabSel(2);
            goto('favourites');
          }} 
          icon={<FavoriteIcon />} 
          label="" 
        />
        <Tab
          style={{
            background: tabSel==3 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==3 ? '#fff' : "",
            position: 'relative'
          }}
          onClick={() => {
            history.push('/profile?' + window.location.href.split("?")[1]);
          }}
          icon={<AccountCircleIcon />}
          label="" 
        />
      </Tabs>
    </Box>
  );
};

export default Cart;
